import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"
import _imports_0 from '../../assets/images/shopping/shopping-shape-3.png'
import _imports_1 from '../../assets/images/shopping/shopping-shape-1.png'
import _imports_2 from '../../assets/images/shopping/shopping-shape-2.png'


const _hoisted_1 = { class: "shopping-wrap pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "col-lg-6 col-12 order-lg-1 order-1" }
const _hoisted_4 = { class: "shopping-img-wrap" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Image",
  class: "shopping-shape-three"
}, null, -1)
const _hoisted_7 = { class: "col-lg-6 col-12 order-lg-2 order-2" }
const _hoisted_8 = { class: "shopping-content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Image",
  class: "shopping-shape-one moveHorizontal"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "Image",
  class: "shopping-shape-two bounce"
}, null, -1)
const _hoisted_11 = { class: "content-title style1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "La Poste du Bénin", -1)
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aproposs, (apropos) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row align-items-center",
          key: apropos.id
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("img", {
                src: _ctx.getUrlApiForFiles(apropos?.urlImage),
                alt: "Image"
              }, null, 8, _hoisted_5),
              _hoisted_6
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", {
                  innerHTML: apropos.annoncedg
                }, null, 8, _hoisted_13)
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}